import { render, staticRenderFns } from "./OrderListHome.vue?vue&type=template&id=c94b1df4&scoped=true&"
import script from "./OrderListHome.vue?vue&type=script&lang=js&"
export * from "./OrderListHome.vue?vue&type=script&lang=js&"
import style0 from "./OrderListHome.vue?vue&type=style&index=0&id=c94b1df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94b1df4",
  null
  
)

export default component.exports